const scheduledServicesUsersFilters = {
  usersFilters: "User Filters",
  searchUsers: "Search Users",
};

export default scheduledServicesUsersFilters;
